import { MajorMilestoneProjectTypeVisibilityBase } from './base/major-milestone-project-type-visibility-base';

export class MajorMilestoneProjectTypeVisibility extends MajorMilestoneProjectTypeVisibilityBase { }